import { SESSION_WARNING_ANNOUNCEMENT } from "../config/sessionTimeout";
import "./SessionCountdownAnnouncement.css";

/**
 * GMA-1909 — the countdown's screen-reader announcement, and ONLY that.
 *
 * It is deliberately separate from the visual countdown, because the visual one
 * is portaled into a shell-provided slot. Moving a subtree between the fallback
 * position and a portal REMOUNTS it, and the slot registers in an effect whose
 * update can be batched with the provider's first deadline: a tab adopting a
 * shared deadline already inside the warning window would then create the
 * aria-live node with its warning text already in it. A live region populated
 * in the same commit that creates it is not reliably announced.
 *
 * So this node is rendered in a stable, never-portaled position and is never
 * unmounted while the app is mounted. Only its text changes.
 *
 * What it says matters as much as when. The visible hint alone never states
 * that sign-out is imminent, and the clock is deliberately not a live region
 * (announcing it would read a new time aloud every second) - so this sentence
 * is the ONLY place a screen-reader user is told what is about to happen.
 */
const SessionCountdownAnnouncement = ({ isWarning }) => (
  <span
    data-testid="session-countdown-announcement"
    className="session-countdown-announcement"
    aria-live="polite"
  >
    {isWarning ? SESSION_WARNING_ANNOUNCEMENT : ""}
  </span>
);

export default SessionCountdownAnnouncement;
